import styled from 'styled-components';
import { FlagIcon } from '@axiom/ui';

import { GENERAL_STYLES_MAP, SIDEBAR_PADDING } from '../../themes/constants';

export const DetailContainer = styled.div`
  display: flex;
  overflow-x: hidden;
`;

export const DetailColumn = styled.div`
  border-left: 1px solid ${GENERAL_STYLES_MAP.DISABLED.background};
  flex: 0 1 50%;
  margin: ${SIDEBAR_PADDING}px 0 0 0;
  max-width: 50%;
  padding: 0 ${SIDEBAR_PADDING}px 2rem ${SIDEBAR_PADDING}px;

  &:first-child {
    border-left: 0;
    padding-left: 0;
  }

  &:last-child {
    padding-right: 0;
  }
`;

export const DrawerContainer = styled.div`
  margin-top: ${SIDEBAR_PADDING}px;
`;

export const FlagIconWrapper = styled(FlagIcon)`
  vertical-align: middle;
  margin-right: 0.5rem;
  height: 1.0625rem;
`;

export const SpanTalentFullName = styled.span`
  vertical-align: middle;
`;
